// Utilidades de formato: fechas en relativo e iniciales, en español.

export function initials(name = "") {
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "?";
}

export function relativeDate(value) {
    if (!value) return "Sin fecha";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "Sin fecha";
    const now = new Date();
    const diff = (now - d) / 1000; // segundos
    const abs = Math.abs(diff);
    const future = diff < 0;
    if (abs < 60) return "ahora mismo";
    const mins = Math.round(abs / 60);
    if (mins < 60) return future ? `en ${mins} min` : `hace ${mins} min`;
    const hours = Math.round(mins / 60);
    if (hours < 24) return future ? `en ${hours} h` : `hace ${hours} h`;
    const days = Math.round(hours / 24);
    if (days === 1) return future ? "mañana" : "ayer";
    if (days < 7) return future ? `en ${days} días` : `hace ${days} días`;
    const weeks = Math.round(days / 7);
    if (weeks < 5) return future ? `en ${weeks} sem.` : `hace ${weeks} sem.`;
    return d.toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric" });
}

export function fullDate(value) {
    if (!value) return "—";
    const d = new Date(value);
    return d.toLocaleDateString("es-ES", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

export function dayKey(value) {
    const d = new Date(value);
    return d.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
}

export const STAGE_LABELS = {
    nuevo: "Nuevo",
    contactado: "Contactado",
    seguimiento: "En seguimiento",
    presentacion: "Presentación",
    convertido: "Convertido",
    descartado: "Descartado",
};

export const STAGE_ORDER = ["nuevo", "contactado", "seguimiento", "presentacion", "convertido"];

export const TYPE_LABELS = {
    cliente: "Cliente",
    equipo: "Equipo",
    sin_clasificar: "Sin clasificar",
};
